import SectionHeading from "./SectionHeading";
import { audience } from "@/mocks/content";

export default function Audience() {
  return (
    <section id="para-quem" className="bg-background-100 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Para quem é"
          title="Se o seu produto vende pelo olhar, o PlayMenu foi feito para você."
          subtitle="Do food truck à operação de food service — quem vive de comida e quer despertar desejo encontra na PlayMenu o seu lugar."
        />

        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {audience.map((card, i) => (
            <div
              key={card.title}
              className="reveal group relative aspect-[3/4] overflow-hidden rounded-xl"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              <img
                src={card.image}
                alt={card.title}
                title={`${card.title} — cardápio digital PlayMenu`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {card.video && (
                <video
                  src={card.video}
                  poster={card.image}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  aria-label={`${card.title} em vídeo`}
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-50">
                  {card.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-300">{card.tagline}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}